<h1 mat-dialog-title class="dialog-title">
  {{ (data.action === 'create' ? 'modal.folder.new' : data.action === 'externalUpload' ? 'modal.file.uploadExt' : 'modal.folder.rename' ) | transloco}}
</h1>
<div mat-dialog-content class="dialog-content">
  <mat-form-field *ngIf="data.action !== 'externalUpload'" appearance="fill">
    <mat-label>{{'modal.folder.name' | transloco}}</mat-label>
    <input matInput [(ngModel)]="data.folderName">
    <mat-error *ngIf="data.errorMessage">{{ data.errorMessage }}</mat-error>
  </mat-form-field>

  <div *ngIf="data.action === 'externalUpload'" class="external-upload-form">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>{{'modal.file.name' | transloco}}</mat-label>
      <input matInput [(ngModel)]="data.fileName">
    </mat-form-field>
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>{{'modal.file.url' | transloco}}</mat-label>
      <input matInput [(ngModel)]="data.fileUrl">
    </mat-form-field>
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>{{'modal.file.provider' | transloco}}</mat-label>
      
      <mat-select [(value)]="data.provider">
        <mat-option *ngFor="let prov of providers" [value]="prov">{{ prov }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>{{'modal.file.type' | transloco}}</mat-label>
      <mat-select [(value)]="data.fileType">
        <mat-option *ngFor="let type of fileTypes" [value]="type">{{ type }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions class="dialog-buttons">
  <button mat-button (click)="onNoClick()" class="cancel">{{'modal.file.cancel' | transloco}}</button>
  <button mat-button (click)="onCreateClick()" class="confirm">{{'modal.file.confirm' | transloco}}</button>
</div>
